export default __webpack_public_path__ + "static/media/brokenChain.f251d445.svg";